import { performances, categories } from "@/data/performances";
import { OfferCard } from "./OfferCard";
import { useState } from "react";

export const Offer = () => {
  const [activeCategory, setActiveCategory] = useState<string | null>(null);

  const filteredCategories = activeCategory 
    ? categories.filter(c => c.slug === activeCategory) 
    : categories;

  return (
    <section id="offer" className="py-24 section-light relative overflow-hidden">
      <div className="absolute inset-0 dot-pattern opacity-20" />
      <div className="container relative z-10">
        <h2 className="text-4xl md:text-5xl font-outfit font-bold text-center mb-4 text-foreground">
          Katalog <span className="text-gradient">atrakcji</span>
        </h2>
        <p className="text-muted-foreground text-center mb-10 max-w-md mx-auto">
          Znajdź idealną atrakcję na swoje wydarzenie firmowe
        </p>

        {/* Category filter pills */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          <button
            onClick={() => setActiveCategory(null)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
              activeCategory === null
                ? "bg-primary text-primary-foreground glow"
                : "bg-card border border-border text-muted-foreground hover:text-foreground hover:border-primary/30"
            }`}
          >
            Wszystkie
          </button>
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(activeCategory === cat.slug ? null : cat.slug)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                activeCategory === cat.slug
                  ? "bg-primary text-primary-foreground glow"
                  : "bg-card border border-border text-muted-foreground hover:text-foreground hover:border-primary/30"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        {/* Category sections */}
        <div className="space-y-16">
          {filteredCategories.map((category) => {
            const categoryPerformances = performances.filter(p => p.category === category.slug);
            if (categoryPerformances.length === 0) return null;

            return (
              <div key={category.slug}>
                <div className="mb-6">
                  <h3 className="text-2xl font-outfit font-bold text-foreground">
                    {category.name}
                  </h3>
                  <p className="text-muted-foreground text-sm mt-1">{category.description}</p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                  {categoryPerformances.map((performance) => (
                    <OfferCard key={performance.slug} performance={performance} />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
